<template>
  <div id="testDrag" class="test-drag" @touchstart=dragStart @touchmove=dragMove @touchend=dragEnd>
    <slot></slot>
  </div>
</template>

<script>
var $ = require('jquery');
window.$ = $;
  export default {
    name: 'container',

    data() {
      return {
        isdrag:true,
        tempX:'',
        tempY:'',
        x:'',
        y:''
      }
    },
    computed: {

    },
    methods: {
      dragStart(event) {
        this.isdrag = true;
        this.tempX = parseInt($("#testDrag").css("left") + 0);
        this.tempY = parseInt($("#testDrag").css("top") + 0);
        this.x = event.touches[0].pageX;
        this.y = event.touches[0].pageY;
      },
      dragMove(event) {
        if (this.isdrag) {
          var curX = this.tempX + event.touches[0].pageX - this.x;
          var curY = this.tempY + event.touches[0].pageY - this.y;
          //边界判断
          curX = curX < 0 ? 0 : curX;
          curY = curY < 0 ? 0 : curY;
          curX = curX < document.documentElement.clientWidth - 40 ? curX : document.documentElement.clientWidth - 40;
          curY = curY < document.documentElement.clientHeight - 40 ? curY : document.documentElement.clientHeight - 40;
          $("#testDrag").css({
            "left": curX,
            "top": curY
          });
          //禁止浏览器默认事件
          event.preventDefault();
        }
      },
      dragEnd() {
        this.isdrag = false;
      }
    },

}
</script>

<style scoped>
  .test-drag {
      position: absolute;
      width: 40px;
      height: 40px;
      z-index: 100;
      right: 4px;
      bottom: 40px;
      background: rgba(255, 255, 255, 0.9);
      color: #fff;
      text-align: center;
      border-radius: 50%;
      font-size:40px;
      line-height: 16px;
      box-sizing: border-box;
      box-shadow: 0 0 3px #666;
    }
</style>
